import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditFacebookPage } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditFacebookPagesPage: FC = () => {
  const { accessToChangeFacebookpage } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeFacebookpage}>
      <CabinetTitlePage
        title={'Facebook page'}
        goBack={'/cabinet/facebook/facebook-pages'}
      />
      <EditFacebookPage />
    </Guard>
  );
};

export default EditFacebookPagesPage;
